import { Mapper } from "../../../../base/utils/mapper";
import { TypeCanalModel } from "../../../../domain/models/configuration/type-canal.model";
import { TypeCanalEntity } from "../entities/type-canal.entity";

export class TypeCanalImplementationRepositoryMapper extends Mapper<TypeCanalEntity, TypeCanalModel> {
    mapFrom(param: TypeCanalEntity): TypeCanalModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeCanalModel): TypeCanalEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}